export const getInteractionContactUrl = (interactionId: number, id: number) =>
  `agency/interactions/${interactionId}/contacts/${id}`;

export const getInteractionNotesUrl = (interactionId: number, id: number) =>
  `agency/interactions/${interactionId}/contacts/${id}/notes`;

export const getInteractionNoteUrl = (interactionId: number, contactId: number, id: number) =>
  `agency/interactions/${interactionId}/contacts/${contactId}/notes/${id}`;
